import { render, staticRenderFns } from "./boundaryEvent.vue?vue&type=template&id=1138f5a2&"
import script from "./boundaryEvent.vue?vue&type=script&lang=js&"
export * from "./boundaryEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports